<template>
  <el-table-column
    :key="field.prop"
    :sortable="field.sortable ? 'custom' : false"
    :prop="field.prop"
    :label="field.label"
    :width="field.width"
    :formatter="formatDate"
  />
</template>

<script>
export default {
  props: ['field'],
  methods: {
    formatDate(row, column, cellValue) {
      if (!cellValue) return ''

      const date = new Date(cellValue)
      return date.toLocaleString('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>
